// extracted by css-extract-rspack-plugin
export default {"SplitPageLayout":"Search-module__SplitPageLayout__U7k73","SplitPageLayout_Content":"Search-module__SplitPageLayout_Content__LGXBu"};